import React, { Component } from 'react';
import i18next from 'i18next';
import classNames from 'classnames';

import * as CustomPropTypes from 'lib/CustomPropTypes';
import PropTypes from 'prop-types';

import ContentTimestamp from 'components/ContentTimestamp';
import Picture from 'components/Picture';
import Unibrow from 'components/Unibrow';

import AIMS_FLAVORS from 'lib/aimsFlavors';
import BTE from 'lib/BTE';
import { imageAltForImage } from 'lib/imageAlt';

import styles from './styles.module.scss';

class SlideshowLede extends Component {
  parallax = [];

  static propTypes = {
    headline: CustomPropTypes.headline.isRequired,
    dek: PropTypes.string,
    unibrow: CustomPropTypes.unibrow.isRequired,
    totalSlides: PropTypes.number.isRequired,
    datePublished: PropTypes.string.isRequired,
    image: CustomPropTypes.image.isRequired,
  }

  static defaultProps = {
    dek: '',
  }

  componentDidMount() {
    BTE.on('scroll', this.handleScroll);
    BTE.monitorImagesLoad();

    BTE.on('imagesLoaded', this.calculateHeight);
    BTE.on('resize', this.calculateHeight);
  }

  componentWillUnmount() {
    BTE.remove('scroll', this.handleScroll);
    BTE.remove('resize', this.calculateHeight);
    BTE.remove('imagesLoaded', this.calculateHeight);
  }

  handleScroll = (depth) => {
    this.moveParallaxLayers(depth);
  }

  calculateHeight = () => {
    const { container } = this;
    const w = window;
    const height = w.innerHeight - (container.getBoundingClientRect().top + w.pageYOffset);
    container.style.height = `${height}px`;
  }

  moveParallaxLayers(depth) {
    /* I want to be able to redefine the properties of each html parallax layer inside forEach */
    /* eslint no-param-reassign: ["error", { "props": false }] */
    this.parallax.forEach((layer) => {
      const thisDepth = layer.getAttribute('data-depth');
      const movement = -(depth * (parseInt(thisDepth, 10) / 100));
      const transformValue = `translate3d(0, ${movement}px, 0)`;
      layer.style.transform = transformValue;
    });
  }

  addParallaxLayer(layer) {
    if (layer && this.parallax.indexOf(layer) === -1) {
      this.parallax.push(layer);
    }
  }

  render() {
    const {
      headline,
      dek,
      unibrow,
      totalSlides,
      datePublished,
      image,
    } = this.props;

    return (
      <div className={styles.container} ref={(box) => { this.container = box; }}>
        <Picture
          className={styles.mainPicture}
          responsiveFlavors={{
            s: AIMS_FLAVORS.FOCAL_360x700,
            m: AIMS_FLAVORS.FOCAL_760x1000,
            l: AIMS_FLAVORS.FOCAL_1000x600,
            xl: AIMS_FLAVORS.FOCAL_1240x800,
          }}
          alt={imageAltForImage(image)}
          url={image.url.primary}
        />

        <div className={styles.patternOverlays} data-depth="50" ref={(element) => { this.addParallaxLayer(element); }} />

        <div className={styles.mainInfoOverlay}>

          <div className={styles.mainInfo} data-depth="20" ref={(element) => { this.addParallaxLayer(element); }}>
            <Unibrow
              className={styles.mainCategory}
              unibrow={unibrow}
            />
            <h1 className={classNames(styles.mainTitle, 'js-article-headline')}>{headline.primary}</h1>
            <p className={styles.mainCopy}>{dek}</p>
          </div>

          <div className={styles.mainMetaShare}>
            <div className={styles.infoWrapper}>
              <span className={styles.mainDate}>
                <span>/ </span>
                <ContentTimestamp
                  datePublished={datePublished}
                  delimiter=" / "
                />
              </span>
              <span className={styles.mainPhotoCount}>
                {totalSlides}
                {' '}
                { i18next.t('PHOTOS') }
              </span>
            </div>
          </div>

        </div>
      </div>
    );
  }
}

export default SlideshowLede;
